export default __webpack_public_path__ + "static/media/about-us.1ca23992.png";